import styled from 'styled-components';

export const Container = styled.div`
  width: auto;
`;

export const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
`;
export const MakecodeIframe = styled.div`
  width: 100%;
  height: 90vh;

  iframe {
    width: 100%;
    height: 100%;
    border-style: none;
  }
`;

export const ButtonDownloadContainer = styled.div`
  margin-top: 1.2rem;

  > .primary-button {
    height: 3.2rem;
    padding: 0 2.4rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 1rem;
    border-radius: 0.6rem;
    box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
    margin-right: 2.72rem;
  }
`;
